import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    CrossIcon,
    StyledLabel,
    StyledTextInput,
    StyledSelectInput,
} from "@aureskonnect/react-ui";
import { AvForm, AvGroup } from "availity-reactstrap-validation";
import { mutate } from "swr";
import { toast } from "react-toastify";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { uuid } from "uuidv4";

import { store } from "@components/VerticalLayout/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import {
    store as device,
    setNumberActive,
    setIsValidateClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsPlusIconClicked,
} from "../store";
import ErrorToast from "@components/Common/ErrorTost";
import { searchPosInArrayObject } from "@helpers/general";
import {
    CustomCardBody,
    CustomCardFooter,
    CustomCardHeader,
} from "@components/Common/CustomCardStyled";
import MultiCustomCreatableSelection from "@components/Common/MultiCustomCreatableSelection";
import MultiCustomSelect from "@components/Common/MultiCustomSelect";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../api/hooks";
import ConfirmationModals from "./ConfirmationModals";
import { ModeOfSaleFormType } from "../types/devise";
import {
    AssociateDevice,
    checkIfDeviceExist,
    checkIfDeviceExistPays,
    checkIfDeviceFranchiseExist,
    fetchDataNameFranchiseArchived,
    stateDevice,
} from "../helpers";
import { showSuccessToast } from "@components/Common/SuccessToast";
import { useSelector } from "react-redux";
import { GetSalesModesTypesAndTagsV2 } from "@pages/SettingGeneral/ModeOfSale/ModeOfSales/helper";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

export default function DeviceForm({
    allDataShops,
    setIsAddDeviceClicked,
    isAddDeviceClicked,
    setDataIsUpdated,
    devises,
    setDevises,
    setLocalFilterActive,
    allDataFanchiseArchived,
    isAddNewDeviseButtonClicked,
    isHistoryModalOpened,
    setIsConsult,
    isConsult,
}: ModeOfSaleFormType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const {
        userID,
        franchiseID,
        shopID,
        oneShop,
        shopPays,
        operatorID,
    } = useSnapshot(store);
    const {
        numberActive,
        shopsDeviceData,
        deviceData,
        deviceDataArchived,
        isActionsClicked,
        isEdited,
        isPlusIconClicked,
        dataShops,
        deviceDataData,
    } = useSnapshot(device);
    const [
        isArchivedFranchiseModalOpened,
        setIsArchivedFranchiseModalOpened,
    ] = React.useState<boolean>(false);
    const [selectCountry, setSelectCountry] = React.useState<boolean>(false);
    const [
        allAssociatedCountryShop,
        setAllAssociatedCountryShop,
    ] = React.useState<any>([]);
    const [designation, setDesignation] = React.useState<string>("");
    const [currencies, setCurrencies] = React.useState<any>([]);
    const [symbol, setSymbol] = React.useState<string>("");
    const [decimalNumber, setDecimalNumber] = React.useState<string>("");
    const [decimalDesignation, setDecimalDesignation] = React.useState<string>(
        ""
    );
    const [isMessageModalOpened, setIsMessageModalOpened] = React.useState<
        boolean
    >(false);
    const [countryList, setCountryList] = React.useState<any>([]);
    const [countryData, setCountryData] = React.useState<any>([]);
    const [tagsData, setTagsData] = React.useState<any>([]);
    const [isSendingTag, setIsSendingTag] = React.useState<boolean>(false);
    const [change, setChange] = React.useState<string>("");
    const [, setExistingDevise] = React.useState<any>({});
    const [inputSymbol, setInputSymbol] = React.useState<boolean>(false);
    const [
        inputdesignationDecimal,
        setInputdesignationDecimal,
    ] = React.useState<boolean>(false);
    const [inputChange, setInputChange] = React.useState<boolean>(false);
    const [inputdecimalNumber, setInputDecimalNumber] = React.useState<boolean>(
        false
    );
    const [, setTag] = React.useState<string>("");
    const [title, setTitle] = React.useState<string>("");

    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [tags, setTags] = React.useState<any[]>([]);
    const [isNameExist, setIsNameExist] = React.useState<boolean>(false);
    const [inputDesignation, setInputDesignation] = React.useState<boolean>(
        false
    );
    const [
        isValidateButtonDisabled,
        setIsValidateButtonDisabled,
    ] = React.useState<boolean>(false);
    const [associated, setAssociated] = React.useState<any[]>([]);
    const [dataEdited, setDataEdited] = React.useState<any>();
    const shopId = oneShop ? shopID : 0;

    let dataDevices: any[] = [];
    let localName: any[] = fetchDataNameFranchiseArchived(
        allDataFanchiseArchived
    );
    const uuidUser = localStorage.getItem("uuidUser");

    const pays = useSelector((state: any) => state.global.pays);

    const handleAddSalesMethodClick = async () => {
        try {
            const configs: any = await GetSalesModesTypesAndTagsV2(
                franchiseID,
                shopId,
                fetchGlobal
            );
            const data = configs[0];

            if (!data) return;

            setCurrencies(
                data.currencies.map((el: any) => {
                    return { label: el.code, value: el.symbol };
                })
            );
            setTags(data.tags);
        } catch (error) {
            console.error("Error fetching sales modes and tags:", error);
        }
    };

    async function addDevice() {
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/devise`;
        let id = uuid();
        let data = {
            userId: userID,
            shopId: oneShop ? [shopId, 0] : [shopId],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            adding: true,
            data: {
                [id]: {
                    Nom_d_Affichage: designation,
                    tag: tagsData.join(","),
                    symbole: symbol,
                    Nbr_décimale: decimalNumber,
                    designation_décimale: decimalDesignation,
                    devise: change,
                    pays: countryData.join(","),
                    isArchived: false,
                    shopId: shopId,
                    isActive: !oneShop,
                },
            },
        };

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        };
        const isDeviceFranchiseExist = checkIfDeviceFranchiseExist({
            allDataShops,
            change,
            t,
        });
        if (isDeviceFranchiseExist && oneShop) {
            setIsMessageModalOpened(!isMessageModalOpened);
        } else if (localName.includes(`${change}`)) {
            setIsArchivedFranchiseModalOpened(true);
        } else {
            try {
                if (
                    oneShop &&
                    deviceDataData?.othersData?.allData?.data?.filter(
                        (x: any) => {
                            return (
                                x?.isArchived === false &&
                                x[t("Currency")] !== change
                            );
                        }
                    )?.length > 0
                ) {
                    ErrorToast(
                        t(
                            "Attention, a franchise cannot have more than one currency"
                        )
                    );

                    return;
                }
                const data: any = await fetchGlobal(apiUrlAdd, requestOptions);
                mutate(apiUrlAdd, data);
                if (data.error) {
                    setDataIsUpdated!(true);
                    throw Error("error");
                }
                showSuccessToast(
                    `${t("The currency has been successfully added")!}`
                );
                setIsSendingTag(true);
                setTagsData([]);
                setDesignation("");
                setTag("");
                setCountryData([]);
                setSymbol("");
                setDataIsUpdated!(true);
                setIsEdited(false);
                setLocalFilterActive(false);
                setDecimalNumber("");
                setDecimalDesignation("");
                setChange("");
                clearData();
                clearMultiCustomSelectionData();
                setInputSymbol(false);
                setNumberActive(numberActive + 1);
                setIsAddDeviceClicked(!isAddDeviceClicked);
            } catch (e) {
                setIsAddDeviceClicked(!isAddDeviceClicked);
                ErrorToast(`${t("There's an error")!}`);
            }
        }
    }

    async function editDevice() {
        setIsValidateClicked(false);
        let dataAssociate: any[] = [];
        toast.dismiss();
        const apiUrlUpdate = `${process.env.REACT_APP_API_V2_URL}/settings/general/devise`;

        if (
            devises[t("Display name")] === designation &&
            devises[t("Currency")] === change &&
            devises[t("Tag")] === tagsData.join(",") &&
            devises[t("Country")] === countryData.join(",") &&
            devises[t("Decimal designation")] === decimalDesignation &&
            devises[t("Nbr decimal")] === decimalNumber &&
            isEdited === false
        ) {
            setIsModalOpened(!isModalOpened);
        } else {
            let isActive: boolean =
                shopId === 0
                    ? stateDevice(shopsDeviceData, devises)
                    : devises.isActive;
            let dataConfig = {
                userId: userID,
                shopId: [shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [devises.id]: {
                        Nom_d_Affichage: designation,
                        tag: tagsData.join(","),
                        symbole: symbol,
                        Nbr_décimale: decimalNumber,
                        designation_décimale: decimalDesignation,
                        devise: change,
                        pays: countryData.join(","),
                        isArchived: devises.isArchived,
                        isActive: isActive,
                        shopId: shopId,
                    },
                },
            };
            setDataEdited(dataConfig);
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataConfig),
            };

            try {
                const data: any = await fetchGlobal(
                    apiUrlUpdate,
                    requestOptions
                );
                if (data.error) {
                    setDataIsUpdated!(true);
                    throw Error("error");
                }
                if (!oneShop) {
                    dataAssociate = AssociateDevice(shopsDeviceData, devises);
                }
                showSuccessToast(
                    !(dataAssociate.length > 0)
                        ? `${t("The currency has been changed successfully")!}`
                        : `${t(
                              "The franchise motto has been successfully changed"
                          )!}`
                );
                if (dataAssociate.length > 0) {
                    setIsModalOpen(true);
                } else {
                    if (!isHistoryModalOpened) setDataIsUpdated!(true);
                    setTagsData([]);
                    setDesignation("");
                    setTag("");
                    setIsSendingTag(true);
                    setCountryData([]);
                    setSymbol("");
                    setIsEdited(false);
                    setLocalFilterActive(false);
                    setDecimalNumber("");
                    setDecimalDesignation("");
                    setChange("");
                    clearData();
                    clearMultiCustomSelectionData();
                    setInputSymbol(false);
                    setIsAddDeviceClicked(!isAddDeviceClicked);
                }
                setIsValidateClicked(true);
            } catch (e) {
                ErrorToast(`${t("There's an error")!}`);
            }
        }
    }

    const formatCreateLabel = (inputValue: any) => (
        <span>
            {inputValue} ({t("New tag")})
        </span>
    );

    useEffect(() => {
        if (devises.id !== undefined) {
            setTitle(t(isConsult ? "View a currency" : "Modify a currency"));
            setDesignation(devises[t("Display name")]);
            setTag(devises[t("Tag")]);
            setSymbol(devises[t("Symbol")]);
            setDecimalNumber(devises[t("Nbr decimal")]);
            setDecimalDesignation(devises[t("Decimal designation")]);
            setCountryData(devises[t("Country")]?.split(","));
            setChange(devises[t("Currency")]);
            setTagsData(devises[t("Tag")]?.split(","));
        } else {
            setDesignation("");
            setTitle(t("Add currency"));
            setTag("");
            setSymbol("");
            setChange("");
            setDecimalNumber("");
            setDecimalDesignation("");
            setCountryData([]);
            setTagsData([]);
            setIsEdited(false);
            setInputChange(false);
            setInputSymbol(false);
        }
        setAssociated(AssociateDevice(shopsDeviceData, devises));

        // eslint-disable-next-line
    }, [isAddNewDeviseButtonClicked, devises.id, t]);

    useEffect(() => {
        clearData();
        clearMultiCustomSelectionData();
    }, [isAddDeviceClicked, devises.id]);

    useEffect(() => {
        handleAddSalesMethodClick();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (Object.values(devises).length !== 0) {
            if (devises[t("Display name")] !== "") {
                setInputDesignation(false);
            }
            if (devises[t("Currency")] !== "") {
                setInputChange(false);
                setInputSymbol(false);
            }
            if (countryData?.length !== 0) {
                setSelectCountry(false);
            }
            if (decimalNumber !== "") {
                setInputDecimalNumber(false);
            }
            if (decimalDesignation !== "") {
                setInputdesignationDecimal(false);
            }
        }
        // eslint-disable-next-line
    }, [devises]);

    React.useEffect(() => {
        let allAssociatedCountryShop: any = [];
        shopsDeviceData.forEach((element: any) => {
            element.subRows.forEach((el: any) => {
                if (devises.id === el.id) {
                    allAssociatedCountryShop.push(element[t("Country")]);
                }
            });
        });

        setAllAssociatedCountryShop([...new Set(allAssociatedCountryShop)]);
        let paysDevise: any = checkIfDeviceExistPays(dataShops);
        setExistingDevise(paysDevise.find((el: any) => el.id === devises.id));
    }, [dataShops, devises, t, shopsDeviceData]);

    useEffect(() => {
        let isDeviceExist = checkIfDeviceExist({
            deviceData,
            deviceDataArchived,
            dataDevices,
            devises,
            change,
            t,
        });
        if (
            isDeviceExist &&
            (devises.id === undefined ||
                (devises.id !== undefined && devises[t("Currency")] !== change))
        ) {
            setIsNameExist(true);
        } else {
            setIsNameExist(false);
        }
        // eslint-disable-next-line
    }, [change, t]);

    React.useEffect(() => {
        deviceData.forEach((el: any) => {
            if (devises.id !== undefined) {
                if (devises.id !== el.id) {
                    dataDevices.push(el);
                }
            }
        });
        //eslint-disable-next-line
    }, [deviceData, devises]);
    React.useEffect(() => {
        if (isPlusIconClicked) {
            setInputDesignation(false);
            setInputSymbol(false);
            setInputChange(false);
            setSelectCountry(false);
            setInputDecimalNumber(false);
            setInputdesignationDecimal(false);
            setIsPlusIconClicked(false);
        }
    }, [isPlusIconClicked]);

    useEffect(() => {
        if (!pays || !Array.isArray(pays)) return;

        if (oneShop) {
            const shopPaysItem =
                pays[searchPosInArrayObject(pays, "label", shopPays)];

            setCountryList(shopPaysItem ? [shopPaysItem.label] : []);
        } else {
            setCountryList(pays.map((el: any) => el.label));
        }
    }, [pays, oneShop, shopPays]);
    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <h5 className="pt-3 dev_txt_FRtitleFormCurrency">
                        {title}
                    </h5>
                    <CrossIcon
                        className="icon-close-notification__clz dev_icn_FRcloseForm"
                        height={13}
                        width={13}
                        onClick={() => {
                            setIsConsult(false);
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    // setDevises([]);
                                    setIsAddDeviceClicked(!isAddDeviceClicked);
                                    setIsEdited(false);
                                    clearData();
                                    clearMultiCustomSelectionData();
                                    // setDataIsUpdated!(true);
                                });
                            } else {
                                setIsAddDeviceClicked(!isAddDeviceClicked);
                                setIsEdited(false);
                                clearData();
                                clearMultiCustomSelectionData();
                                // setDataIsUpdated!(true);
                            }
                        }}
                    />
                </CustomCardHeader>
                <CustomCardBody
                    className={`pl-3 pr-5 `}
                    style={{
                        maxHeight: "480px",
                        overflowY: " scroll",
                    }}
                >
                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Currency")}
                        </StyledLabel>

                        <StyledSelectInput
                            isClearable
                            autoFocus={devises.id === undefined}
                            className={classnames("dev_inp_FRcurrency", {
                                invalid__clz: inputChange || isNameExist,
                                "not-allowed-input__clz": devises.id,
                            })}
                            noOptionsMessage={() => t("No options")}
                            options={currencies}
                            autocomplete="off"
                            name="change"
                            onChange={(e: any) => {
                                if (e !== null) {
                                    setChange(e.label);

                                    setSymbol(e.value);
                                    setDesignation(e.label);
                                } else {
                                    setChange("");
                                    setSymbol("");
                                }
                                setIsEdited(true);
                                setInputChange(false);
                                setInputSymbol(false);
                                setInputDesignation(false);
                            }}
                            value={
                                change === ""
                                    ? null
                                    : {
                                          label: change,
                                          value: change,
                                      }
                            }
                            placeholder={`${t("Select")}…`}
                            type="text"
                        />
                        {inputChange ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please select a change")}
                            </div>
                        ) : null}
                        {isNameExist ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("The Currency already exists")!}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Display name")}
                        </StyledLabel>
                        <StyledTextInput
                            className={classnames("dev_inp_FRdisplayName", {
                                input__clz:
                                    inputDesignation ||
                                    (designation.trim() === "" &&
                                        designation !== ""),
                            })}
                            autocomplete="off"
                            name="Display name"
                            onChange={(e: any) => {
                                setDesignation(e.target.value.trim());
                                setIsEdited(true);
                                setInputDesignation(false);
                            }}
                            value={designation}
                            placeholder={t("Write")}
                            type="text"
                        />
                        {inputDesignation ||
                        (designation.trim() === "" && designation !== "") ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please enter a display name")}
                            </div>
                        ) : null}
                    </AvGroup>

                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Symbole")}
                        </StyledLabel>
                        <StyledTextInput
                            className="not-allowed-input__clz dev_inp_FRsymbol"
                            autocomplete="off"
                            name="symbol"
                            value={symbol}
                            placeholder={t("Symbole")}
                            type="text"
                        />
                        {inputSymbol ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please select a change")}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Decimal designation")}
                        </StyledLabel>
                        <StyledTextInput
                            className={classnames(
                                "dev_inp_FRdecimalDesignation",
                                {
                                    input__clz:
                                        inputdesignationDecimal ||
                                        (decimalDesignation.trim() === "" &&
                                            decimalDesignation !== ""),
                                    " not-allowed-input__clz":
                                        devises.id && oneShop,
                                }
                            )}
                            autocomplete="off"
                            name="decimal designation"
                            onChange={(e: any) => {
                                setDecimalDesignation(e.target.value.trim());
                                setIsEdited(true);

                                setInputdesignationDecimal(false);
                            }}
                            value={decimalDesignation}
                            placeholder={t("Write")}
                            type="text"
                        />
                        {inputdesignationDecimal ||
                        (decimalDesignation.trim() === "" &&
                            decimalDesignation !== "") ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please enter a decimal designation")}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Decimal number")}
                        </StyledLabel>

                        <StyledSelectInput
                            maxMenuHeight="80px"
                            placeholder={`${t("Select")}…`}
                            className={classnames("dev_inp_FRdecimalNumber", {
                                invalid__clz: inputdecimalNumber,
                                " not-allowed-input__clz":
                                    devises.id && oneShop,
                            })}
                            value={
                                decimalNumber === ""
                                    ? null
                                    : {
                                          label: decimalNumber,
                                          value: decimalNumber,
                                      }
                            }
                            onChange={(e: any) => {
                                setIsEdited(true);
                                setInputDecimalNumber(false);
                                e !== null
                                    ? setDecimalNumber(e.label)
                                    : setDecimalNumber("");
                            }}
                            isClearable
                            options={[
                                {
                                    label: "1",
                                    value: "1",
                                },
                                {
                                    label: "2",
                                    value: "2",
                                },
                                {
                                    label: "3",
                                    value: "3",
                                },
                                {
                                    label: "4",
                                    value: "4",
                                },
                            ]}
                            name="mark"
                            noOptionsMessage={() => t("No options")}
                        />
                        {inputdecimalNumber ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please select a decimal number")}
                            </div>
                        ) : null}
                    </AvGroup>

                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Country")}
                        </StyledLabel>
                        <MultiCustomSelect
                            onDelete={(e: any) => {
                                setIsEdited(true);
                            }}
                            result={countryData}
                            setResult={setCountryData}
                            data={countryList}
                            onChange={(e: any) => {
                                setIsEdited(true);
                                setSelectCountry(false);
                            }}
                            className={classnames("dev_inp_FRcountry", {
                                invalid__clz: selectCountry,
                            })}
                            blocked={devises.id !== undefined && oneShop}
                            placeholder={`${t("Select")}…`}
                            blockedList={
                                oneShop
                                    ? countryList && devises.id
                                    : allAssociatedCountryShop
                            }
                            value={t("Choose")}
                            name="country"
                        />
                        {selectCountry ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please select a country")}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                        <StyledLabel htmlFor="text" className="mt-3">
                            {t("Tag")}
                        </StyledLabel>
                        <MultiCustomCreatableSelection
                            onDelete={() => {
                                setIsEdited(true);
                            }}
                            isSendingTag={isSendingTag}
                            setResult={setTagsData}
                            result={tagsData}
                            className="dev_inp_FRtags"
                            data={tags}
                            onChange={(e: any) => {
                                setIsEdited(true);
                            }}
                            onCreateOption={(e: any) => {
                                setIsEdited(true);
                            }}
                            placeholder={`${t("Select")}…`}
                            value={t("Choose")}
                            name="tag"
                            noOptionsMessage={() => t("No options")}
                            formatCreateLabel={formatCreateLabel}
                        />
                        <div className="d-flex flex-wrap"></div>
                    </AvGroup>
                </CustomCardBody>
                <CustomCardFooter className="pt-1 pb-2">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        className="mr-2 dev_btn_FRcancel cmn_btn_cancel"
                        variant="light"
                        onClick={() => {
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    setIsAddDeviceClicked(!isAddDeviceClicked);
                                    setDataIsUpdated!(true);
                                });
                            } else {
                                setIsAddDeviceClicked(!isAddDeviceClicked);
                                setDataIsUpdated!(true);
                            }
                            setIsConsult(false);
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        className={`dev_btn_FRvalidate cmn_btn_validate ${
                            isConsult ? "not-allowed-input__clz" : ""
                        }`}
                        disabled={isValidateButtonDisabled}
                        onClick={() => {
                            setIsValidateButtonDisabled(true);

                            if (change === "") {
                                setInputChange(true);
                                setInputSymbol(true);
                            }
                            if (decimalNumber === "")
                                setInputDecimalNumber(true);
                            if (decimalDesignation === "")
                                setInputdesignationDecimal(true);
                            if (countryData.length === 0) {
                                setSelectCountry(true);
                            }
                            if (designation === "") setInputDesignation(true);
                            else if (
                                devises.id !== undefined &&
                                designation.trim() !== "" &&
                                !isNameExist &&
                                change !== "" &&
                                decimalNumber !== "" &&
                                decimalDesignation.trim() !== "" &&
                                countryData.length !== 0
                            ) {
                                editDevice();
                            } else if (
                                designation.trim() !== "" &&
                                !isNameExist &&
                                change !== "" &&
                                decimalNumber !== "" &&
                                decimalDesignation.trim() !== "" &&
                                countryData.length !== 0
                            ) {
                                if (deviceData.length > 0 && oneShop) {
                                    ErrorToast(
                                        t(
                                            "Attention, a shop cannot have more than one currency"
                                        )
                                    );
                                } else {
                                    addDevice();
                                }
                            }
                            setTimeout(() => {
                                setIsValidateButtonDisabled(false);
                            }, 500);
                        }}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>
            <ConfirmationModals
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                setIsAddDeviceClicked={setIsAddDeviceClicked}
                setDevises={setDevises}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                setIsEdited={setIsEdited}
                setDataIsUpdated={setDataIsUpdated}
                dataEdited={dataEdited}
                associated={associated}
                isMessageModalOpened={isMessageModalOpened}
                setIsMessageModalOpened={setIsMessageModalOpened}
                setTagsData={setTagsData}
                setInputSymbol={setInputSymbol}
                setDesignation={setDesignation}
                setCountryData={setCountryData}
                setDecimalNumber={setDecimalNumber}
                setDecimalDesignation={setDecimalDesignation}
                setChange={setChange}
                setTag={setTag}
                setSymbol={setSymbol}
                setIsSendingTag={setIsSendingTag}
                setLocalFilterActive={setLocalFilterActive}
                designation={designation}
                change={change}
                tagsData={tagsData}
                allDataShops={allDataShops}
                countryData={countryData}
                t={t}
                isArchivedFranchiseModalOpened={isArchivedFranchiseModalOpened}
                setIsArchivedFranchiseModalOpened={
                    setIsArchivedFranchiseModalOpened
                }
            />
        </React.Fragment>
    );
}
